import { ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnInit, SimpleChanges } from '@angular/core';
import { LayoutService } from '../../services/theme/layout.service';
import icBookmarks from '@iconify/icons-ic/twotone-bookmarks';
import emojioneUS from '@iconify/icons-emojione/flag-for-flag-united-states';
import emojioneDE from '@iconify/icons-emojione/flag-for-flag-germany';
import icMenu from '@iconify/icons-ic/twotone-menu';
import { ConfigService } from '../../services/theme/config.service';
import { map } from 'rxjs/operators';
import icPersonAdd from '@iconify/icons-ic/twotone-person-add';
import icAssignmentTurnedIn from '@iconify/icons-ic/twotone-assignment-turned-in';
import icBallot from '@iconify/icons-ic/twotone-ballot';
import icDescription from '@iconify/icons-ic/twotone-description';
import icAssignment from '@iconify/icons-ic/twotone-assignment';
import icReceipt from '@iconify/icons-ic/twotone-receipt';
import icDoneAll from '@iconify/icons-ic/twotone-done-all';
import { NavigationService } from '../../services/theme/navigation.service';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import { PopoverService } from '../../components/popover/popover.service';
import { MegaMenuComponent } from '../../components/mega-menu/mega-menu.component';
import icSearch from '@iconify/icons-ic/twotone-search';
import { MatDialog, MatTabChangeEvent } from '@angular/material';
import { AddEditEmploymentComponent } from 'src/app/modules/employment/employment/add-edit-employment/add-edit-employment.component';
import { AddEditJobComponent } from 'src/app/modules/job/job/add-edit-job/add-edit-job.component';
import { roles } from 'src/app/shared/helpers/roles-permissions';
import { SignContractComponent } from '../../../app/public/sign-contract/sign-contract.component';
import { NavigationEnd, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { API_ACCOUNT_CREDIT } from 'src/@core/services/util/api.endpoints';
import { AppService } from 'src/@core/services/app.service';
import { CreditsService } from 'src/@core/services/credits/credits.service';
import { Subscription, BehaviorSubject } from 'rxjs';
import { SubscriptionPlansService } from 'src/app/modules/subscription-plans/subscription-plans.service';
import { ThemeService } from 'src/@core/services/theme.service';
import { Config } from 'src/@core/interfaces/theme/config.model';
import { permissions } from 'src/app/shared/helpers/roles-permissions';
import { JobService } from 'src/@core/services/job/job.service';

/** Project page `?tab=` values, in tab order — matches ViewProjectNewComponent. */
const PROJECT_TAB_PARAMS = ['search', 'connected', 'assigned', 'tasks', 'funnel', 'loop', 'agent-evals'];

/** The tabs this toolbar shows, in order. The project page also has a 'tasks' tab that is not listed here. */
const TOOLBAR_TAB_PARAMS = ['search', 'connected', 'assigned', 'agent-evals', 'funnel', 'loop'];

@Component({
  selector: 'codemiro-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  @Input() mobileQuery: boolean;
  @Input() hideSidePanel: boolean;
  @Input() projectDetails: any;

  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;

  roles = roles;

  navigationItems = this.navigationService.items;
  pageNavigator$ = this.layoutService.pageNavigator$; // Subscribe to layout service for page navigator
  projectDetails$ = this.layoutService.projectDetails$; // Subscribe to layout service for project details
  private projectDetailsSubscription: Subscription;

  isHorizontalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'horizontal'));
  isVerticalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'vertical'));
  isNavbarInToolbar$ = this.configService.config$.pipe(map(config => config.navbar.position === 'in-toolbar'));
  isNavbarBelowToolbar$ = this.configService.config$.pipe(map(config => config.navbar.position === 'below-toolbar'));
  config: Config;
  icSearch = icSearch;
  icBookmarks = icBookmarks;
  emojioneUS = emojioneUS;
  emojioneDE = emojioneDE;
  icMenu = icMenu;
  icPersonAdd = icPersonAdd;
  icAssignmentTurnedIn = icAssignmentTurnedIn;
  icBallot = icBallot;
  icDescription = icDescription;
  icAssignment = icAssignment;
  icReceipt = icReceipt;
  icDoneAll = icDoneAll;
  icArrowDropDown = icArrowDropDown;
  profile = this.app.getCurrentAccount();
  credits: any = null;
  currentUserRole: any = null;
  walletBalance: any = null;
  subscrier: Subscription;
  currentUserSubscription: any;
  imageUrl$: any = this.configService.config$.pipe(map(config => config.sidenav.imageUrl));
  permissions = permissions;
  public showProjectTabs: boolean = false;
  public projectName: string = null;
  selectedTabIndex: any;

  private boundRefreshCreditsListener: any;

  constructor(private layoutService: LayoutService,
    private configService: ConfigService,
    private navigationService: NavigationService,
    private popoverService: PopoverService,
    private dialog: MatDialog,
    private router: Router,
    private http: HttpClient,
    private app: AppService,
    public subscriptionPlansService: SubscriptionPlansService,
    public creditsService: CreditsService,
    public themeService: ThemeService,
    public jobService: JobService,
    private cdRef: ChangeDetectorRef) {
    this.subscrier = this.creditsService.getRefreshCreditsHeader().subscribe(res => {
      this.getCredits();
      this.getCashCredits();
    });
  }

  ngOnInit() {
    // Initialize projectDetails if not set via @Input
    if (!this.projectDetails) {
      this.projectDetails = {};
    }

    this.getCurrentRole();
    this.getCurrentUserSubscription();

    this.router.routerState.root.queryParams.subscribe(params => {
      const index = TOOLBAR_TAB_PARAMS.indexOf(params['tab']);
      this.selectedTabIndex = index === -1 ? 0 : index;
    });
    console.log("projectDetails", this.projectDetails)


    const currentUrl = this.router.url.split('?')[0];

    // Match exactly this pattern: /job/view-new-project/:uuid (and nothing after that)
    const match = currentUrl.match(/^\/job\/view-new-project\/[^\/]+$/);
    this.showProjectTabs = !!match;

    // ✅ Immediately handle direct load (refresh)
    // if (this.showProjectTabs) {
    //   const urlSegments = currentUrl.split('/');
    //   const projectId = urlSegments[urlSegments.indexOf('view-new-project') + 1];
    //   const entityId = this.profile && this.profile.entity && this.profile.entity.id;
    //   if (entityId && projectId) {
    //     this.getProjectById(entityId, projectId);
    //   }
    // }

    // ✅ Also listen to route changes for in-app navigation
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event instanceof NavigationEnd) {
          const currentUrl = event.urlAfterRedirects.split('?')[0];
          const match = currentUrl.match(/^\/job\/view-new-project\/[^\/]+$/);
          this.showProjectTabs = !!match;
        }

        // if (this.showProjectTabs) {
        //   const projectId = urlSegments[urlSegments.indexOf('view-new-project') + 1];
        //   const entityId = this.profile && this.profile.entity && this.profile.entity.id;
        //   if (entityId && projectId) {
        //     this.getProjectById(entityId, projectId);
        //   }
        // }
      }
    });

    // Add event listener for refreshCredits event
    this.boundRefreshCreditsListener = this.refreshCreditsListener.bind(this);
    window.addEventListener('refreshCredits', this.boundRefreshCreditsListener);

    // Subscribe to project details from layout service
    this.projectDetailsSubscription = this.projectDetails$.subscribe(details => {
      if (details && details.project_name) {
        // Initialize projectDetails if it doesn't exist
        if (!this.projectDetails) {
          this.projectDetails = {};
        }
        this.projectDetails.project_name = details.project_name;
        this.projectName = details.project_name; // Also update projectName for consistency
        this.cdRef.detectChanges(); // Trigger change detection to update the view
      } else if (details === null) {
        // Clear project details when null is emitted
        this.projectDetails = null;
        this.projectName = null;
        this.cdRef.detectChanges();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.projectDetails && changes.projectDetails.currentValue) {
      const details = changes.projectDetails.currentValue;
      if (details.project_name) {
        this.projectName = details.project_name;
      }
    }
  }

  getProjectById(entityId: string, projectId: string) {
    console.log('project details retrieved successfully:');
    this.jobService.getHoaProject(entityId, projectId).subscribe(
      (response) => {
        console.log("###", response);
        this.projectDetails = response;
        if (response && response.project_name) {
          this.projectName = response.project_name;
        }
      }, (err => {
      })
    )
  }

  onTabChanged(event: MatTabChangeEvent) {
    const selectedTab = TOOLBAR_TAB_PARAMS[event.index] || 'search';
    this.router.navigate([], {
      queryParams: { tab: selectedTab },
      queryParamsHandling: 'merge'
    });
  }

  // get current user role
  getCurrentRole() {
    this.app.currentUser.subscribe(currentUser => {
      if (currentUser && currentUser.roles && currentUser.roles.length) {
        currentUser.roles.forEach(ele => {
          this.currentUserRole = ele;
          this.getCredits();
          this.getCashCredits();
        })
      }
    })
  }

  // openQuickpanel() {
  //   this.layoutService.openQuickpanel();
  // }

  openSidenav() {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement) {
    this.popoverService.open({
      content: MegaMenuComponent,
      origin,
      position: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });
  }

  openSearch() {
    this.layoutService.openSearch();
  }

  opeNewEmploymentDialog() {
    const dialogRef = this.dialog.open(AddEditEmploymentComponent, {
      width: '770px',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.dataChange.next(1);
      }
    });
  }
  createShift() {
    this.router.navigate(['/create-shift']);
  }

  opeNewJobDialog() {
    this.router.navigate(['/add-edit-job-template']);
    return;
    const data = {
      title: 'Create Job Template'
    };
    const dialogRef = this.dialog.open(AddEditJobComponent, {
      width: '700px',
      disableClose: true,
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.dataChange.next(result.id);
      }
    });
  }

  // Sign contract
  signContract() {
    const data = {
      title: 'Sign Contract'
    };
    const dialogRef = this.dialog.open(SignContractComponent, {
      width: '1000px',
      maxHeight: '1000px',
      disableClose: true,
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.dataChange.next(result.id);
      }
    });
  }

  // get Credits
  public getCredits() {
    // if (this.currentUserRole == 'ENTERPRISE_ADMIN' || this.currentUserRole == 'ENTERPRISE_STAFF' || this.currentUserRole == 'AGENCY_ADMIN' || this.currentUserRole == 'AGENCY_STAFF') {
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      this.creditsService.fetchTaskCreditBalance(this.app.getCurrentAccount().entity.id).subscribe(
        (response) => {
          console.log(response)
          response.remainCredits = response.taskCredits - response.usedCredits;
          this.credits = response;
        }, (error) => {
          console.error('Failed to fetch wallet balance:', error);
        })
    }
    // }
  }

  public refreshCredits() {
    this.getCredits();
  }

  getCashCredits() {
    if (this.currentUserRole == 'ENTERPRISE_ADMIN' || this.currentUserRole == 'AGENCY_ADMIN') {
      if (this.profile && this.profile.entity && this.profile.entity.id) {
        this.creditsService.fetchWalletBalance(this.app.getCurrentAccount().entity.id).subscribe(
          (response) => {
            this.walletBalance = response.result;
          }, (error) => {
            console.error('Failed to fetch cash wallet balance:', error);
          })
      }
    }
  }

  getCurrentUserSubscription() {
    const account = this.app.getCurrentAccount();
    if (account && account.user) {
      this.subscriptionPlansService.fetchCurrentUserSubscription().subscribe(
        (response) => {
          this.currentUserSubscription = response;
          console.log("current user subscription details: ", this.currentUserSubscription);

          if (this.currentUserSubscription && this.currentUserSubscription.planMetaData) {
            // Plan metadata exists, user is on a paid plan
          } else if (account.entity && account.entity.id) {
            // No paid plan, possibly trial — fetch entity info for trial plan name and status
            this.getEntityDetails(account.entity.id);
          }
        }, (error) => {
          console.error("Failed to fetch current user's subscription details:", error);
        });
    }
  }

  getEntityDetails(entityId: string) {

    this.subscriptionPlansService.getEntityDetails(entityId).subscribe(
      (res) => {
        console.log("Trial Plan Info:", res);
        this.currentUserSubscription = {
          subscriptionStatus: res.subscriptionStatus,
          subscriptionPlanName: res.subscriptionPlanName
        };
      },
      (error) => {
        console.error("Error fetching entity details:", error);
      }
    );
  }

  goToCreditSection() {
    this.router.navigateByUrl('/credit-usage/credit-list');
  }

  login() {
    this.router.navigate(['/']);
  }

  changeTheme(event: any) {
    this.themeService.isDarkTheme = event.checked;
    this.themeService.toggleTheme();
    let imageUrl = "";
    if (this.themeService.isDarkTheme) {
      imageUrl = "assets/logo.svg";
    } else {
      imageUrl = "assets/logo.svg";
    }
    this.configService.updateConfig({
      sidenav: {
        imageUrl: imageUrl
      }
    });
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.subscrier.unsubscribe();
    // Remove event listener for refreshCredits event
    window.removeEventListener('refreshCredits', this.boundRefreshCreditsListener);
    // Unsubscribe from project details
    if (this.projectDetailsSubscription) {
      this.projectDetailsSubscription.unsubscribe();
    }
  }

  goToProjects() {
    this.router.navigate(['/job']);
  }

  // Listener for refreshCredits event
  private refreshCreditsListener = () => {
    this.getCredits();
    this.getCashCredits();
  };
}